import { hasAccessAgentFeature } from 'helpers/agentHelper';

// eslint-disable-next-line import/prefer-default-export
export const userHasAccessAgentFeature = () => {
  return hasAccessAgentFeature();
};
